import { createExportLocale } from "../export-locale";

export default createExportLocale({
  action: "Экспорт",
  markdown: "Отчёт Markdown",
  csv: "Таблица CSV",
  printSavePdf: "Печать / Сохранить как PDF",
  completed: "Экспорт отчёта готов.",
  failed: "Не удалось экспортировать отчёт.",
  context: "Охват и основа представления",
  generatedAt: "Создано: {generatedAt}",
  asOf: "По состоянию на",
  period: "За период",
  accountFilter: "Фильтр по счёту",
  advancedFilter: "Расширенный фильтр",
  interval: "Интервал",
  conversion: "Конвертация",
  notApplied: "Не применено",
  currency: "Валюта",
  unit: "Единица",
  amount: "Сумма",
  unauditedManagementReport: "Неаудированный управленческий отчёт",
  unauditedMultiUnitManagementReport:
    "Неаудированная управленческая ведомость в нескольких единицах",
  unauditedInternalDraft: "Неаудированный внутренний черновик",
  statementSummary: "Краткий отчёт",
  lineItem: "Статья",
  totalAssets: "Итого активы",
  totalLiabilities: "Итого обязательства",
  totalEquity: "Итого капитал",
  totalLiabilitiesAndEquity: "Итого обязательства и капитал",
  reconciliationDifference: "Разница сверки",
  totalRevenue: "Итого выручка и прочие доходы",
  totalExpenses: "Итого расходы",
  netLoss: "Чистый убыток",
  netCashOperating: "Чистый денежный поток от операционной деятельности",
  netCashInvesting: "Чистый денежный поток от инвестиционной деятельности",
  netCashFinancing: "Чистый денежный поток от финансовой деятельности",
  netChangeInCash: "Чистое изменение денежных средств и эквивалентов",
  openingCash: "Денежные средства и эквиваленты на начало периода",
  closingCash: "Денежные средства и эквиваленты на конец периода",
  supportingAccountDetail: "Дополнительная детализация счетов",
  allActivity: "Вся доступная активность книги по",
  dateUnavailable: "Дата отчёта недоступна",
  presentationCurrency: "Валюта представления",
  ledgerUnits: "Показанные единицы книги",
  sourceLedger: "Исходная книга",
  importantNotices: "Важные примечания",
  reportingEntity: "Отчитывающийся субъект",
  netIncome: "Чистый доход",
  reportingEntityFallbackNotice:
    'Отчитывающийся субъект не задан. Используется имя исходной книги; перед внешним использованием задайте Beancount option "title".',
  placeholderDataNotice:
    "Отчитывающийся субъект или исходная книга, вероятно, содержит демонстрационные данные. Замените их перед внешним использованием.",
  inferredPeriodNotice:
    "Этот отчёт охватывает операции книги с {startDate} по {endDate}. Даты определены по доступным данным отчёта.",
  periodNotExplicitNotice:
    "Полный отчётный период определить не удалось. Этот отчёт остаётся внутренним черновиком.",
  inferredAsOfDateNotice:
    "Явная отчётная дата не выбрана. Используется последняя доступная дата отчёта: {asOfDate}.",
  asOfDateUnavailableNotice:
    "Не удалось определить дату баланса. Этот отчёт остаётся внутренним черновиком.",
  subtotalRowsNotice:
    "Строки, выделенные жирным, являются промежуточными или итоговыми суммами; их не следует складывать с относящимися к ним строками детализации.",
  partialReportNotice:
    "Фильтры по счёту или расширенные фильтры ограничивают отчёт; это не полный комплект финансовой отчётности.",
  balanceSheetClassificationNotice:
    "Исходная книга не содержит классификации на оборотные и внеоборотные статьи; счета представлены в порядке книги.",
  balanceSheetDoesNotReconcileNotice:
    "Бухгалтерское равенство не сходится по одной или нескольким единицам. Перед внешним использованием проверьте незакрытые результаты, частичные фильтры, влияние оценки или пересчёта и ошибки книги. Отчёт остаётся внутренним черновиком.",
  cashFlowClassificationNotice:
    "Разделение на операционную, инвестиционную и финансовую деятельность выводится из типов и названий счетов без объявленного cash-flow-role; счета с таким объявлением классифицируются как указано.",
  cashFlowCashEquivalentsNotice:
    "Состав денежных средств и эквивалентов определяется по названиям счетов (текущие, сберегательные и кассовые счета). Проверьте включённые счета перед внешним использованием.",
  customUnitsNotice: "Пользовательские единицы, требующие проверки:",
  customUnitsDefinitionNotice:
    "Их значения не указаны в этом экспорте; перед внешним использованием опишите их в сопроводительном примечании.",
  multiUnitScheduleNotice:
    "Этот отчёт в нескольких единицах является управленческой ведомостью, а не финансовой отчётностью в одной валюте представления. Не складывайте суммы в разных единицах; перед внешним использованием выберите валюту представления.",
  noAssurance:
    "Уверенность не предоставляется. Отчёт подготовлен по данным пользователя; личность субъекта, полнота, оценка и соответствие стандартам не проверены.",
  generatedBy: "Создано Beancount.io: {generatedAt}",
});
